import Terms from './Terms-view';

export default Terms;
